/*

  f e a t u r e s  -  t e k n o s a  s y n d i c a t i o n
  Features - Teknosa Syndication Slice

  :description:
  Our reducer for the teknosa syndication feature.

*/

//
//  :react & redux:
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

//
//  :code:
import { submitTeknosaForm } from './tenkosaSyndicationAPI';

//
//  :statics:

//
//  :functions:

//
//  :state:
//  Our initial state object.
const initialState = {
  formSubmission: {
    status: "idle",
    requesting: false,
    error: null,
    response: null,
  }
};

//
//  :async actions:
export const formSubmissionAsync = createAsyncThunk(
  'teknosaSyndication/teknosaFormSubmission',
  async (payload) => {
    const response = await submitTeknosaForm(payload)
    return response
  }
);

//
//  :reducer:
export const teknosaSyndicationSlice = createSlice({
  name: 'teknosaSyndication',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(formSubmissionAsync.pending, (state) => {
        state.formSubmission.status = 'requesting';
        state.formSubmission.requesting = true
        state.formSubmission.error = null
        state.formSubmission.response = null
      })
      .addCase(formSubmissionAsync.fulfilled, (state, action) => {
        state.formSubmission.status = 'idle';
        state.formSubmission.requesting = false
        state.formSubmission.response = action.payload
      })
      .addCase(formSubmissionAsync.rejected, (state, action) => {
        state.formSubmission.status = 'error';
        state.formSubmission.requesting = false
        state.formSubmission.error = action.error
      })
  },
});

//
//  :exports:
export const selectFormSubmissionStatus = (state) => state.teknosaSyndicationSlice.formSubmission.status;
export const selectFormSubmissionRequesting = (state) => state.teknosaSyndicationSlice.formSubmission.requesting;
export const selectFormSubmissionError = (state) => state.teknosaSyndicationSlice.formSubmission.error;
export const selectFormSubmissionResponse = (state) => state.teknosaSyndicationSlice.formSubmission.response;

//
//  :exports:
export default teknosaSyndicationSlice.reducer;